import { useEffect, useReducer } from 'react'
import { apiGet } from '../../../generic/Api_Functions'

const NextJob = ({ partId, setCurrentLinkedJobReference }) => {
  const onJobLinkedDataDispatch = (oldData, action) => {
    switch (action.type) {
      case 'SET_PART_REFERENCE_WORKFLOW':
        return { ...oldData, partReferenceWorkflow: action.value }
      case 'SET_CURRENT_LINKED_JOB_REFERENCE':
        setCurrentLinkedJobReference(action.value)
        return { ...oldData, currentLinkedJobReference: action.value }
      default:
        return oldData
    }
  }

  const [WorkflowData, dispatchWorkflowData] = useReducer(onJobLinkedDataDispatch, { partReference: null, partReferenceWorkflow: null, currentLinkedJobReference: null })

  useEffect(() => {
    const getPartReferenceWorkflowByPartId = async () => {
      const data = await apiGet('workflow/part/' + partId)
      dispatchWorkflowData({ type: 'SET_PART_REFERENCE_WORKFLOW', value: data, creating: false })
    }

    if (partId) {
      getPartReferenceWorkflowByPartId()
    }
  }, [partId])

  if (!WorkflowData.partReferenceWorkflow) {
    return <></>
  }

  return <div style={{ width: '100%', height: '50vh', display: 'grid' }} />
}

export default NextJob
